export const ORDER_TAB = {
  INFO: 'info',
  // DOCUMENTS: 'documents',
  // ACTIVITY_NOTES: 'activity_notes',
};

export const OPPORTUNITY_TAB = {
  INFO: 'info',
  ACTIVITY_NOTES: 'activity_notes',
  DOCUMENTS: 'documents',
};

// eslint-disable-next-line import/prefer-default-export
export const ORDER_DETAIL_TABS = Object.values(ORDER_TAB);
// eslint-disable-next-line import/prefer-default-export
export const OPPORTUNITY_TABS = Object.values(OPPORTUNITY_TAB);
